const calculateShipping = (orderValue, shippingType) => {
    // Convert orderValue to number and handle invalid inputs
    const value = Number(orderValue);
    if (isNaN(value) || value < 0) {
        throw new Error('Invalid order value');
    }

    // Define shipping costs
    const SHIPPING_COSTS = {
        express: {
            minValue: 0,
            maxValue: 399.99,
            cost: 14.79,
            freeShippingThreshold: 400
        },
        standard: {
            minValue: 0,
            maxValue: 399.99,
            cost: 9.59,
            freeShippingThreshold: 400
        }
    };

    // Validate shipping type
    if (!['express', 'standard'].includes(shippingType.toLowerCase())) {
        throw new Error('Invalid shipping type. Use "express" or "standard"');
    }

    const shippingMethod = SHIPPING_COSTS[shippingType.toLowerCase()];

    // Check if order qualifies for free shipping
    if (value >= shippingMethod.freeShippingThreshold) {
        return 0;
    }

    // Return shipping cost if within valid range
    if (value >= shippingMethod.minValue && value <= shippingMethod.maxValue) {
        return shippingMethod.cost;
    }

    return 0;
};

// Example usage:
// const orderValue = 350;
// console.log('Express shipping:', calculateShipping(orderValue, 'express')); // 14.79
// console.log('Standard shipping:', calculateShipping(orderValue, 'standard')); // 9.59
